import React from 'react';
import PropTypes from 'prop-types';

import { dig } from 'spiceutils';

import SingleSurvey from './SingleSurvey';
import MultipleSurveys from './MultipleSurveys';

const SurveyList = (props) => {
  const updateCDF = (value) => {
    if (value) {
      props.updateCDF([
        {
          field: 'SurveyList',
          value,
        },
        {
          field: 'YearsToShow',
          value: null,
        },
      ]);
    } else {
      props.updateCDF('SurveyList', null);
    }
  };

  if (dig(props.controlList, ['SurveyList', 'Visible']) === true) {
    switch (dig(props.controlList, ['SurveyList', 'Type'])) {
      case 'select':
        return (
          <div>
            <label htmlFor="SurveyList">Survey</label>
            <SingleSurvey
              cdf={props.cdf}
              onChange={updateCDF}
              controlList={props.controlList.SurveyList}
              id="SurveyList"
            />
          </div>
        );
      case 'multiSelect':
        return (
          <div>
            <label htmlFor="SurveyList">Surveys</label>
            <MultipleSurveys
              cdf={props.cdf}
              onChange={updateCDF}
              controlList={props.controlList.SurveyList}
              id="SurveyList"
            />
          </div>
        );
      default:
        return null;
    }
  }
  return null;
};

SurveyList.propTypes = {
  cdf: PropTypes.object,
  controlList: PropTypes.object,
  updateCDF: PropTypes.func,
};

export default SurveyList;



// WEBPACK FOOTER //
// ./app/components/FormControls/SurveyList/index.js